import React, { useRef } from 'react';
import { useEditor } from './EditorContext';
import { addImageToCanvas } from '../canvasEditor';
import uploadApi from '../../../api/uploadApi';

export default function CanvasToolbar() {
  const fileRef = useRef(null);
  const { fabricRef, setLayersOpen, layersOpen, refreshLayers } = useEditor();

  const onLoadImage = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fc = fabricRef.current;
    if (!fc) return;

    try {
      const path = await uploadApi.upload(file);
      await addImageToCanvas(fc, path, { name: 'image', niceName: 'image' });
      refreshLayers?.();
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      console.error('Image upload failed', msg, err);
    }
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <div className="pixie-canvas-toolbar">
      <button type="button" className="pixie-toolbar-btn" onClick={() => fileRef.current?.click()}>
        <i className="fa-solid fa-image" aria-hidden /> LOAD IMAGE
      </button>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        className="pixie-hidden-input"
        onChange={onLoadImage}
      />
      <button
        type="button"
        className={`pixie-toolbar-btn ${layersOpen ? 'active' : ''}`}
        onClick={() => setLayersOpen((v) => !v)}
      >
        <i className="fa-solid fa-layer-group" aria-hidden /> LAYERS
      </button>
    </div>
  );
}
